import { convertLegacyRouteRefs } from '@backstage/core-compat-api';
import {
  createPlugin,
  createRoutableExtension,
} from '@backstage/core-plugin-api';
import { CreateAppRouteBinder } from '@backstage/frontend-app-api';

import { ExternalRoutes, Routes, rootRouteRef } from './routes';

export const explorePlugin = createPlugin({
  id: 'confidence-explore',
  routes: {
    ...Routes,
  },
  externalRoutes: {
    ...ExternalRoutes,
  },
});

export const bindExploreRoutes = (
  bind: CreateAppRouteBinder,
  extraRoutes?: Parameters<typeof convertLegacyRouteRefs>[0],
) => {
  bind(
    convertLegacyRouteRefs(explorePlugin.externalRoutes),
    convertLegacyRouteRefs({
      ...explorePlugin.routes,
      ...extraRoutes,
    }),
  );
};

export const ConfidenceExplorePage = explorePlugin.provide(
  createRoutableExtension({
    name: 'ConfidenceExplorePage',
    component: () =>
      import(
        /* webpackChunkName: "confidence-explore", webpackPrefetch: 10 */ './Router'
      ).then(m => m.Router),
    mountPoint: rootRouteRef,
  }),
);
